import { mountGame } from '../render/three/game-app.js';
import { acesupSpec } from '../variants/acesup/spec.js';

await mountGame(acesupSpec);
